<template>
  <a-config-provider :locale="locale">
    <!-- iframe 模式：只显示 router-view 内容 -->
    <div v-if="isIframeMode" class="iframe-mode">
      <router-view v-if="isRouterAlive" />
    </div>
    <!-- 正常模式：完整布局 -->
    <div v-else class="normal-mode">
      <div class="consolePage">
        <v-menu :collapsed="collapsed" />
        <div class="consolePageRight">
          <!-- 头部信息 -->
          <div class="header_info_box">
            <!-- 左侧区域 -->
            <div class="header_info_box_left">
              <a-icon :type="menuIconType" class="menu-toggle-icon" @click="toggleCollapsed" />

              <!-- 首页：显示企业信息 -->
              <template v-if="isShowHome">
                <CompanyInfoPop v-if="userInfo.company" ref="CompanyInfoPop">
                  <img :src="userInfo.company.logo" class="company-logo" />
                  <span class="companyName">{{ userInfo.company.companyName }}</span>
                </CompanyInfoPop>

                <div v-if="levelPhoto" class="levelBox">
                  <img :src="levelPhoto" class="levelPhoto" />
                  <template v-if="updateBoxInfo.content">
                    <span class="update-text">{{ updateBoxInfo.content }}</span>
                    <img :src="updateBoxInfo.btnSrc" class="upgrade-btn" @click="toUpgrade" />
                  </template>
                </div>
              </template>

              <!-- 非首页：显示面包屑 -->
              <v-breadcrumbs v-else class="breadcrumbs" />
            </div>

            <!-- 右侧区域 -->
            <a-space class="header_info_box_right" size="middle">
              <a-input-search
                v-if="isShowHome"
                v-model="searchValue"
                allowClear
                placeholder="搜索客户"
                @search="handleSearchCustomer"
              />
              <a-icon type="logout" class="logout-icon" @click="logout" />
            </a-space>
          </div>

          <div class="content-wrapper">
            <router-view v-if="isRouterAlive" class="page-content" />
          </div>
        </div>
      </div>

      <!-- 企业认证的modal -->
      <a-modal
        :visible="!!certModalType"
        :title="$t('提示')"
        :okText="$t('提升权益')"
        :cancelText="$t('取消')"
        @cancel="handleCertModalCancel"
        @ok="handleCertModalOk"
      >
        <p>{{ $t('您暂无此权限, 如需使用, 请提升权益') }}</p>
      </a-modal>

      <!-- 完善企业云展系统 modal 认证成功后才弹出  -->
      <ImproveSystemModalVue :visible="isShowCompeteSystem && roleId > 1" />

      <PopUpLogin />
      <hwChatModal ref="chat" :show-home-btn="true" />
    </div>
  </a-config-provider>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import enUS from 'ant-design-vue/lib/locale-provider/en_US'

import vMenu from '@/components/base/consoleMenu.vue'
import vBreadcrumbs from '@/components/base/breadcrumb'
import PopUpLogin from '@/components/login/PopUpLogin.vue'
import hwChatModal from '@/components/chat/index.vue'
import ImproveSystemModalVue from '~/components/website/dialog/improveSystemModal.vue'
import CompanyInfoPop from '@/components/layout/topHeaderComponents/CompanyInfoPop.vue'

import { goRoleConsole } from '@/utils/util'
import headerMixin from '@/components/layout/mixin/headerMixin'
import { logoutMixin } from '~/mixin/logout-mixin'
import { Role, System } from '@/const/constConfig'
import {
  VIP_LEVEL_0,
  VIP_LEVEL_1,
  VIP_LEVEL_2,
  VIP_LEVEL_3,
  VIP_LEVEL_4,
  VIP_LEVEL_5,
  VIP_LEVEL_6,
  VIP_LEVEL_7,
  VIP_LEVEL_8,
} from '@/const/image'

// VIP 等级图片映射
const VIP_LEVEL_MAP = {
  110000: VIP_LEVEL_0,
  10000: VIP_LEVEL_1,
  20000: VIP_LEVEL_2,
  30000: VIP_LEVEL_3,
  40000: VIP_LEVEL_4,
  50000: VIP_LEVEL_5,
  60000: VIP_LEVEL_6,
  70000: VIP_LEVEL_7,
  80000: VIP_LEVEL_8,
}

// 首页路由列表
const HOME_ROUTES = ['/visitor', '/organizer', '/exhibitor', '/contractors', '/designer']

export default {
  name: 'ConsoleLayout',
  components: {
    hwChatModal,
    vMenu,
    vBreadcrumbs,
    PopUpLogin,
    ImproveSystemModalVue,
    CompanyInfoPop,
  },
  mixins: [headerMixin, logoutMixin],
  provide() {
    return {
      reload: this.reload,
    }
  },
  middleware: ['auth-ssr'],
  data() {
    return {
      System,
      Role,
      locale: this.$locale,
      isRouterAlive: true,
      collapsed: false,
      searchValue: '',
    }
  },
  computed: {
    ...mapState({
      companyFlag: (state) => state.userInfo.companyFlag,
      roleId: (state) => state.userInfo.roleId,
      isShowCompeteSystem: (state) => state.isShowCompeteSystem,
      accountLevel: (state) => state.userInfo.accountLevel,
      supplyUnicode: (state) => state.supplyUnicode,
      supplyChainInfo: (state) => state.supplyChainInfo,
    }),
    ...mapGetters({
      certModalType: 'certModalType',
      userInfo: 'userInfo',
      allUnReadNum: 'chat/allUnReadNum',
    }),
    // 判断是否为 iframe 模式
    isIframeMode() {
      return this.$route.query.iframe === '1'
    },
    // 菜单折叠图标类型
    menuIconType() {
      return this.collapsed ? 'menu-unfold' : 'menu-fold'
    },
    // 如果是首页, 显示企业名称, logo等, 如果不是, 显示面包屑
    isShowHome() {
      return HOME_ROUTES.includes(this.$route.path)
    },
    isShowMemberInfo() {
      return (
        this.$route.path === this.$store.getters.getConsolePath &&
        !(
          this.accountLevel === Role.AccountLevel.Child ||
          (this.companyFlag === System.Identity.Person &&
            (this.$store.getters.roleId === 5 || this.$store.getters.roleId === 4))
        )
      )
    },

    // 等级图片
    levelPhoto() {
      const setMealCode = this.userInfo?.memberSetMealInfo?.setMealCode
      return setMealCode ? VIP_LEVEL_MAP[setMealCode] || null : null
    },
    // 升级/续费信息
    updateBoxInfo() {
      const memberInfo = this.userInfo?.memberSetMealInfo
      if (!memberInfo) {
        return { content: '', btnSrc: '' }
      }

      const baseUrl = 'https://oss-resource668.yzdli.com/website/image/default/upgradeVip/'
      const isZh = this.$i18n.locale === 'zh'
      const isBase = memberInfo.isBase === 1

      return {
        content: isBase ? '升级企业套餐,享更多专属权益' : `${this.$t('到期时间')}:${memberInfo.expiredTme}`,
        btnSrc: isBase
          ? `${baseUrl}btn_upgrade${isZh ? '' : '_en'}.png`
          : `${baseUrl}btn_xufei${isZh ? '' : '_en'}.png`,
      }
    },
  },
  watch: {
    supplyUnicode(newVal) {
      if (newVal) {
        this.getUserInfo()
      }
    },
  },
  mounted() {
    // 设置语言
    const localeMap = { zh: zhCN, en: enUS }
    this.locale = localeMap[this.$store.state.locale] || this.locale

    // 等待路由完全解析后再执行角色检查逻辑
    this.$router.onReady(() => this.getUserInfo())
  },
  methods: {
    // 刷新路由视图
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },

    // 切换菜单折叠状态
    toggleCollapsed() {
      this.collapsed = !this.collapsed
    },

    // 获取用户信息
    async getUserInfo() {
      const res = await this.$store.dispatch('getUserInfo')
      if (res?.code !== 0 || !res.data.roleId) return

      // 如果刚注册的参观商角色停留在参观商路径时,被审核通过。获取最新的角色id进行跳转
      const currentRolePath = `/${this.$route.path.split('/')[1]}`
      const targetPath = goRoleConsole(res.data.roleId)

      // 只有当用户在 /visitor 路径，但角色已不是 visitor 时才跳转
      if (currentRolePath === '/visitor' && targetPath !== '/visitor') {
        this.$router.push(targetPath)
      }
    },

    // 前往升级/续费页面
    toUpgrade() {
      this.$router.push('/upgradevip')
    },

    // 认证弹窗取消
    handleCertModalCancel() {
      this.$store.commit('SWITCH_SHOW_CART', false)
    },

    // 认证弹窗确认
    handleCertModalOk() {
      this.$store.commit('SWITCH_SHOW_CART', false)
      this.$router.push('/upgradevip')
    },

    // 搜索客户
    handleSearchCustomer() {
      const path = `${this.$store.getters.getConsolePath}/cces/count/myCustomerDatabase`
      this.$router.push({ path, query: { searchValue: this.searchValue } })
    },
  },
}
</script>
<style lang="scss" scoped>
.normal-mode {
  background: #f6f7f8;
}

.consolePage {
  position: relative;
  display: flex;
  min-width: fit-content;
  height: 100vh;

  .consolePageRight {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden; // 防止内容溢出，使内部滚动生效
    min-width: 0; // 允许 flex 子元素收缩
  }
}

.header_info_box {
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 62px;
  line-height: 62px;
  width: 100%;
  padding: 0 24px;
  background: #fff;
  box-sizing: border-box;

  .header_info_box_left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .menu-toggle-icon {
    cursor: pointer;
    font-size: 18px;
  }

  .company-logo {
    width: 34px;
    height: 34px;
  }

  .companyName {
    color: #333;
    font-weight: 500;
    font-size: 16px;
  }

  .levelBox {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .levelPhoto {
    width: 52px;
  }

  .update-text {
    color: #ed7b30;
  }

  .upgrade-btn {
    cursor: pointer;
  }

  .breadcrumbs {
    margin-left: 8px;
  }

  .logout-icon {
    cursor: pointer;
  }
}

.content-wrapper {
  flex: 1;
  padding: 24px;
  margin-top: 62px;
  overflow: auto;
  max-width: 100%;
  box-sizing: border-box;
  background: #f3f3f3;
}

.page-content {
  flex: 1;
  margin-bottom: 20px;
  background-color: #fff;
  min-width: 0; // 允许内容收缩，使表格滚动生效
}

.iframe-mode {
  background: #fff;
  min-height: 100vh;
}
</style>
